import {CheckoutGateway, registerPaymentMethod} from '@paymentplugins/wc-stripe/checkout';

class UPMCheckoutGateway extends CheckoutGateway {
    constructor(...props) {
        super(...props);
    }

    initializeSetupIntent(throwError = false, context = '') {
        if (this.is_current_page('add_payment_method')) {
            return super.initializeSetupIntent(throwError);
        }
        if (context === 'place_order' && this.shouldCreatePaymentMethod()) {
            return super.initializeSetupIntent(throwError, context);
        }
    }

}

registerPaymentMethod(
    new UPMCheckoutGateway(wc_stripe_upm_checkout_params, '#wc-stripe-upm-element')
)
